module.exports = {"469027100":"抱由镇","469027101":"万冲镇","469027102":"大安镇","469027103":"志仲镇","469027104":"千家镇","469027105":"九所镇","469027106":"利国镇","469027107":"黄流镇","469027108":"佛罗镇","469027109":"尖峰镇","469027110":"莺歌海镇","469027401":"国营山荣农场","469027402":"国营乐光农场","469027405":"国营保国农场","469027500":"国营尖峰岭林业公司","469027501":"国营莺歌海盐场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469027.json
// module id = 2031
// module chunks = 0